import React, { ComponentType, lazy, Suspense } from 'react';
import { Container } from '@uds/grid';
import { Panel } from '@uds/panel';
import { useBreakpoints } from '@ux/responsive';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { Colorway } from '@uds/theme-utils';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import Ribbon from 'components/ribbons/Ribbon';
import RibbonPending from 'components/ribbons/Ribbon/RibbonPending';

import { CellProps } from './Cell';

const CompactTable = lazy(() => import('./CompactTable'));
const WideTable = lazy(() => import('./WideTable'));

interface OuterProps extends RibbonProps {
  head: Array<CellProps>;
  body: Array<Array<CellProps>>;
}

export const PureTable = ({ id, colorway, name, layout, loading, head, body, hBaseline = 1 }: OuterProps) => {
  const borderless = [Colorway.PRIMARY, Colorway.PRIMARY_GRADIENT, Colorway.HIGHLIGHT].includes(colorway);
  const { isMinMd } = useBreakpoints();
  const Table = isMinMd ? WideTable : CompactTable;

  return (
    <Suspense fallback={<RibbonPending colorway={colorway} layout={layout} />}>
      <Ribbon id={id} colorway={colorway} layout={layout} loading={loading} type={Type.TABLE} name={name}>
        <Container>
          <Panel border={!borderless}>
            <Table colorway={colorway} head={head} body={body} hBaseline={hBaseline} />
          </Panel>
        </Container>
      </Ribbon>
    </Suspense>
  );
};

PureTable.displayName = 'Table';

export default visibilitySet(errorBoundary(PureTable)) as ComponentType<OuterProps>;
